"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Tooltip: ()=>Tooltip,
    ValidTooltipColorValues: ()=>ValidTooltipColorValues
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const tooltip_namespaceObject = require("@base-ui-components/react/tooltip");
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const tooltipStyles = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        baseSlot: 'text-body3 rounded-xl px-3 py-2 transition-all',
        iconSlot: 'mr-1',
        arrowSlot: 'w-(--tooltip-arrow-size) h-(--tooltip-arrow-size) rotate-45 rounded-tl-[3px] [clip-path:polygon(0%_0%,0%_100%,100%_0%)]',
        arrowContainerSlot: 'data-[side=bottom]:top-(--tooltip-arrow-offset-y) data-[side=left]:right-(--tooltip-arrow-offset-x) data-[side=right]:left-(--tooltip-arrow-offset-x) data-[side=top]:bottom-(--tooltip-arrow-offset-y) data-[side=left]:rotate-90 data-[side=right]:-rotate-90 data-[side=top]:rotate-180'
    },
    variants: {
        color: {
            neutral: {},
            success: {},
            error: {}
        },
        emphasis: {
            true: {},
            false: {}
        },
        showArrow: {
            true: {},
            false: {}
        },
        fixedWidth: {
            true: {},
            false: {}
        }
    },
    compoundSlots: [
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            class: 'shadow-lg'
        },
        {
            slots: [
                'baseSlot'
            ],
            fixedWidth: false,
            class: 'w-auto'
        },
        {
            slots: [
                'baseSlot'
            ],
            fixedWidth: true,
            class: 'w-44'
        },
        {
            slots: [
                'arrowSlot'
            ],
            showArrow: false,
            class: 'invisible'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            emphasis: false,
            class: 'bg-neutral-1'
        },
        {
            slots: [
                'baseSlot'
            ],
            emphasis: false,
            color: 'neutral',
            class: 'text-neutral-11'
        },
        {
            slots: [
                'baseSlot'
            ],
            emphasis: false,
            color: 'success',
            class: 'text-success-11'
        },
        {
            slots: [
                'baseSlot'
            ],
            emphasis: false,
            color: 'error',
            class: 'text-error-11'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            emphasis: true,
            color: 'neutral',
            class: 'bg-neutral-8 text-neutral-1'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            emphasis: true,
            color: 'success',
            class: 'bg-success-8 text-neutral-1'
        },
        {
            slots: [
                'baseSlot',
                'arrowSlot'
            ],
            emphasis: true,
            color: 'error',
            class: 'bg-error-8 text-neutral-1'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: false,
            color: 'neutral',
            class: 'text-neutral-10'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: false,
            color: 'success',
            class: 'text-success-8'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: false,
            color: 'error',
            class: 'text-error-8'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: true,
            color: 'neutral',
            class: 'text-neutral-4'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: true,
            color: 'success',
            class: 'text-success-7'
        },
        {
            slots: [
                'iconSlot'
            ],
            emphasis: true,
            color: 'error',
            class: 'text-error-7'
        },
        {
            slots: [
                'baseSlot'
            ],
            class: 'motion-safe:data-[starting-style]:animate-fade-in-0-100 transition-duration-extra-short motion-safe:data-[ending-style]:animate-fade-out-100-0 transition-duration-snap'
        }
    ]
});
const ValidTooltipColorValues = Object.keys(tooltipStyles.variants.color);
function Tooltip(props) {
    const { children, triggerNode, className, iconLeft, color = 'neutral', align = 'center', side = 'bottom', showArrow = true, alignOffset = 0, sideOffset = 10, fixedWidth = false, emphasis = false, delay = 600, closeDelay = 0, hoverable = true, open, defaultOpen = false, onOpenChange } = props;
    const { baseSlot, iconSlot, arrowContainerSlot, arrowSlot } = tooltipStyles({
        color,
        emphasis,
        showArrow,
        fixedWidth
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(tooltip_namespaceObject.Tooltip.Root, {
        delay: delay,
        closeDelay: closeDelay,
        hoverable: hoverable,
        defaultOpen: defaultOpen,
        open: open,
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(tooltip_namespaceObject.Tooltip.Trigger, {
                className: className,
                render: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {}),
                children: triggerNode
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(tooltip_namespaceObject.Tooltip.Portal, {
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(tooltip_namespaceObject.Tooltip.Positioner, {
                    align: align,
                    alignOffset: alignOffset,
                    side: side,
                    sideOffset: sideOffset,
                    arrowPadding: 16,
                    className: "z-1",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(tooltip_namespaceObject.Tooltip.Popup, {
                        className: baseSlot(),
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(tooltip_namespaceObject.Tooltip.Arrow, {
                                className: arrowContainerSlot(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                    className: arrowSlot(),
                                    "data-testid": "tooltip-arrow"
                                })
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: "flex flex-row items-start justify-center",
                                children: [
                                    iconLeft && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                                        iconName: iconLeft,
                                        className: iconSlot(),
                                        size: "16"
                                    }),
                                    children
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
exports.Tooltip = __webpack_exports__.Tooltip;
exports.ValidTooltipColorValues = __webpack_exports__.ValidTooltipColorValues;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Tooltip",
    "ValidTooltipColorValues"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
